export var Status;
(function (Status) {
    Status["Act"] = "act";
    Status["Watch"] = "watch";
    Status["Maintain"] = "maintain";
    Status["NoData"] = "nodata";
})(Status || (Status = {}));
export var ScoreTitles = {
    capability: "Leadership Capability",
    functional: "Business Impact: Functional",
    organizational: "Business Impact: Organizational",
    potential: "Leadership Potential",
};
export var ScoreDescriptions = {
    capability: "Current Leadership Skills",
    functional: "Role-specific past experiences & accomplishments",
    organizational: "Role-agnostic past experiences & accomplishments",
    potential: "Future Leadership Outlook",
};
export var SuccesionScoreDescriptions = {
    statement1: "of leaders have no path forward",
    statement2: "of leaders are in 3+ pipelines",
};
export var getColorUndefinableDecider = function (colorDescriptions) { return function (score) {
    return colorDescriptions.find(function (_a) {
        var low = _a.low, high = _a.high;
        return score >= low && score < high;
    });
}; };
export var getColorDecider = function (colorDescriptions) { return function (score) {
    return getColorUndefinableDecider(colorDescriptions)(score) ||
        colorDescriptions[colorDescriptions.length - 1];
}; };
export var getDescriptionDecider = function (colorDescriptions, skillGroup) {
    return function (score) {
        var _a, _b, _c;
        return ((_b = (_a = getColorDecider(colorDescriptions)(score)) === null || _a === void 0 ? void 0 : _a.description) === null || _b === void 0 ? void 0 : _b[skillGroup]) ||
            ((_c = colorDescriptions[colorDescriptions.length - 1].description) === null || _c === void 0 ? void 0 : _c[skillGroup]) ||
            "";
    };
};
